import {addRemoveProductToTemporaryOrder, getOrderFeeLimits, getOrderVolumeDiscounts, moveUnconfirmedLinesToNextOrder, setActiveOrder, submitOrder} from "../actions/order.js";
import {clearQuery, editQueryFilter, loadMoreSearchedProducts, prepareQueryOptions} from "../actions/productQuery.js";
import {getBoughtProducts, getNewProducts} from "../actions/productLists.js";
import {setDropDown, setModal} from "../../common/actions/modal";

import OrderProductsPage from "../components/order/OrderProductsPage.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../common/util/reselect.js";
import {createFlowControl} from "../../common/util/flowControl";
import {createLocalization} from "../../common/util/localization.jsx";
import {initiateCurrentOrder} from "../actions/worker.js";
import {scssVariables} from "../../common/util/config.jsx";
import {setOrderProductView} from "../actions/order.js";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    const flowControlCounter = createFlowControl();

    return (state, ownProps) => ({
        startView: ownProps.match.params.view || "card",
        localization: createLocalization(state),
        productView: state.order.productView,
        deviceType: state.view.deviceType,
        productQuery: state.productQuery,
        flowControl: flowControl,
        flowControlCounter: flowControlCounter,
        activeOrder: state.order.active,
        productImage: state.productImage,
        width: state.view.innerWidth,
        deliveryDates: state.delivery.dates.deliveryDates || [],
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        productLists: state.productLists,
        orderFeeLimits: state.order.orderFeeLimits,
        orderVolumeDiscounts: state.order.orderVolumeDiscounts,
        newSeasonDistrDates : state.authentication.newSeasonDistrDates || [],
        showFreshFood: state.authentication.showFreshFood,
    });
};

const mapDispatchToProps = {
    setOrderProductView,
    loadMoreSearchedProducts,
    editQueryFilter,
    clearQuery,
    addRemoveProductToTemporaryOrder,
    submitOrder,
    setActiveOrder,
    initiateCurrentOrder,
    moveUnconfirmedLinesToNextOrder,
    setModal,
    setDropDown,
    prepareQueryOptions,
    getBoughtProducts,
    getNewProducts,
    getOrderFeeLimits,
    getOrderVolumeDiscounts,
};

const myAddRemoveProductToTemporaryOrder = createBoundFunction();
const myLoadMoreSearchedProducts = createBoundFunction();
const myEditQueryFilter = createBoundFunction();
const mySubmitOrder = createBoundFunction();
const mySetActiveOrder = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    addRemoveProductToTemporaryOrder: myAddRemoveProductToTemporaryOrder((product, qty, salesLineId) => dispatchProps.addRemoveProductToTemporaryOrder(stateProps.activeOrder, product, qty, salesLineId)),
    loadMoreSearchedProducts: myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts)),
    submitOrder: mySubmitOrder(() => dispatchProps.submitOrder(stateProps.activeOrder)),
    setActiveOrder: mySetActiveOrder((shipmentId, distributionRouteId, deliveryDate, waitForReservation) => dispatchProps.setActiveOrder(shipmentId, distributionRouteId, deliveryDate, waitForReservation)),
    editQueryFilter: myEditQueryFilter( (change) => dispatchProps.editQueryFilter(stateProps.productQuery, stateProps.productImage, change, 
        myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts))
    )),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OrderProductsPage);